import React from "react";
import {Box, Button, IconButton, Tooltip, Typography} from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import {exportImage, getDpeColor} from "../dpeByIris/MapPage";
import InfoIcon from "@mui/icons-material/Info";
import FlatDpe from "../../component/FaltDpe";
import {computeSurfUtile} from "../../component/RightAccordion";
import CloseIcon from '@mui/icons-material/Close';
import {checkSecondaire} from "../../component/v2/BatimentsDetails";

function getMeta(selectedItem) {
    return selectedItem.meta;
}

export function formatTexte(valeur) {
    if (valeur) {

        let str = valeur.toLowerCase().replaceAll('"', "").replaceAll('{', "").replaceAll('}', "");

        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return "";
}

export function getMultiText(meta, key) {
    let valeur = {};

    meta.forEach((item) => {
        if (item[key]) {

            if (!valeur[item[key]]) {
                valeur[item[key]] = 0
            }
            valeur[item[key]]++;
        }
    })

    return Object.keys(valeur).join(", ");
}

export default function KpiView({selectedItem, showDetails, close}) {

    function getAdresse(selectedItem) {
        let adresse = getMeta(selectedItem)
        let a = adresse?.numero + " " + adresse?.type_voie + " " + adresse?.nom_voie;
        if (a === "  ") {
            a = "Pas de données";
        }
        return a.toLowerCase()
    }

    function getNbNeighbors(selectedItem) {
        let adresse = getMeta(selectedItem)

        return Number(adresse.nb_adresses);
    }


    function getText(valeur, item) {
        if (valeur[item]) {
            return formatTexte(valeur[item]);
        }
        return "Pas de données";
    }

    function getTextNotZero(valeur, item) {
        if (valeur[item]) {
            if (Number(valeur[item]) === 0) {
                return "Pas de données";
            }
            return valeur[item] + " m²";
        }
        return "Pas de données";
    }


    function getDpesV1(listOfDpeV1) {
        let res = [];
        listOfDpeV1.forEach((item) => {
            res.push({"classe_bilan_dpe": item.classe_conso_energie_arrete_2012});
        })
        return res;

    }

    function getDpesV2(dpesV2) {
        let res = [];
        Object.keys(dpesV2).forEach((item) => {
            res.push({"classe_bilan_dpe": dpesV2[item].etiquette_dpe});

        })

        return res;
    }

    const [takeScreenshot, setTakeScreenshot] = React.useState(false);
    const printRef = React.useRef();
    React.useEffect(() => {

        if (printRef && takeScreenshot) {

            exportImage(printRef, selectedItem.cle_interop_adr).then(() => {
                setTakeScreenshot(false);
            }).catch((e) => {
                console.error("Error exporting image:", e);
            });
        }
        setTakeScreenshot(false);
    }, [printRef, takeScreenshot]);

    if (!selectedItem) {
        return null;
    }


    function getDpes(selectedItem) {
        let empty = true;
        let res = []
        if (Object.keys(selectedItem.listOfDpesV2Immeuble).length > 0) {
            empty = false;
            let dpes = {}
            Object.keys(selectedItem.listOfDpesV2Immeuble).forEach((item) => {
                if (!dpes[selectedItem.listOfDpesV2Immeuble[item]["etiquette_dpe"]]) {
                    dpes[selectedItem.listOfDpesV2Immeuble[item]["etiquette_dpe"]] = 0;
                }
                dpes[selectedItem.listOfDpesV2Immeuble[item]["etiquette_dpe"]]++;
            })
            res.push(<Box sx={{marginTop: 2}} key={"dpeV2Immeuble"}>
                    <Box sx={{
                        display: "flex",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start"

                    }}>
                        <Box sx={{width: "80%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>Catégorie DPE opposables retenue immeuble :
                            </Typography>
                        </Box>
                        <Box sx={{width: "20%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(selectedItem.stats.dpeV2),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2"
                                >{selectedItem.stats.dpeV2}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52
                    }}>
                        <Tooltip
                            title="Les DPE immeuble réalisés après juillet 2021 sont opposables et présentent une fiabilité accrue">
                            <IconButton>
                                <InfoIcon/>
                            </IconButton>
                        </Tooltip>

                        <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                    gutterBottom>{Object.keys(selectedItem.listOfDpesV2Immeuble).length} DPE opposables
                            immeuble réalisés
                            après
                            juillet 2021
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52,
                    }}>

                        <FlatDpe
                            values={getDpesV2(selectedItem.listOfDpesV2Immeuble)}
                            labels={["G", "F", "E", "D", "C", "B", "A"]}
                            colors={["#f71e1a", "#f79b40", "#f6c824", "#f7f72b", "#cefc43", "#43ce3f", "#2d682e"]}/>
                    </Box>
                </Box>
            );
        }
        if (Object.keys(selectedItem.listOfDpesV2).length > 0) {
            empty = false;
            let dpes = {}
            Object.keys(selectedItem.listOfDpesV2).forEach((item) => {
                if (!dpes[selectedItem.listOfDpesV2[item]["etiquette_dpe"]]) {
                    dpes[selectedItem.listOfDpesV2[item]["etiquette_dpe"]] = 0;
                }
                dpes[selectedItem.listOfDpesV2[item]["etiquette_dpe"]]++;
            })
            res.push(<Box sx={{marginTop: 2}}
                          key={"dpeV2"}>
                    <Box sx={{
                        display: "flex",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start"

                    }}>
                        <Box sx={{width: "80%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>Catégorie DPE opposables retenue logements :
                            </Typography>
                        </Box>
                        <Box sx={{width: "20%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(selectedItem.stats.dpeV2),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2"
                                >{selectedItem.stats.dpeV2}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52
                    }}>
                        <Tooltip
                            title="Les DPE réalisés après juillet 2021 sont opposables et présentent une fiabilité accrue">
                            <IconButton>
                                <InfoIcon/>
                            </IconButton>
                        </Tooltip>

                        <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                    gutterBottom>{Object.keys(selectedItem.listOfDpesV2).length} DPE opposables
                            logements réalisés
                            après
                            juillet 2021
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52,
                    }}>

                        <FlatDpe
                            values={getDpesV2(selectedItem.listOfDpesV2)}
                            labels={["G", "F", "E", "D", "C", "B", "A"]}
                            colors={["#f71e1a", "#f79b40", "#f6c824", "#f7f72b", "#cefc43", "#43ce3f", "#2d682e"]}/>
                    </Box>
                </Box>
            );
        }
        if (Object.keys(selectedItem.listOfDpesV2).length === 0 && selectedItem?.listOfDpesV1?.length > 0) {
            empty = false;
            let dpes = {}
            Object.keys(selectedItem.listOfDpesV1).forEach((item) => {
                if (!dpes[selectedItem.listOfDpesV1[item]["classe_conso_energie_arrete_2012"]]) {
                    dpes[selectedItem.listOfDpesV1[item]["classe_conso_energie_arrete_2012"]] = 0;
                }
                dpes[selectedItem.listOfDpesV1[item]["classe_conso_energie_arrete_2012"]]++;
            })


            res.push(<Box sx={{marginTop: 2}} key={"dpeV1"}>
                    <Box sx={{
                        display: "flex",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start"

                    }}>
                        <Box sx={{width: "80%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>Catégorie DPE opposables retenue :
                            </Typography>
                        </Box>
                        <Box sx={{width: "20%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(selectedItem.stats.dpeV1),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2"
                                >{selectedItem.stats.dpeV1}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52
                    }}>
                        <Tooltip
                            title="Les DPE réalisés avant juillet 2021 net sont opposables">
                            <IconButton color={"error"}>
                                <InfoIcon/>
                            </IconButton>
                        </Tooltip>

                        <Typography sx={{fontWeight: 300, color: "#ff0000"}} variant="body2" display="block"

                                    gutterBottom>{selectedItem?.listOfDpesV1?.length} DPE opposables logements réalisés
                            avant
                            juillet 2021
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start", height: 52,
                    }}>

                        <FlatDpe
                            values={getDpesV1(selectedItem.listOfDpesV1)}
                            labels={["G", "F", "E", "D", "C", "B", "A"]}
                            colors={["#f71e1a", "#f79b40", "#f6c824", "#f7f72b", "#cefc43", "#43ce3f", "#2d682e"]}/>
                    </Box>
                </Box>
            );
        }
        if (empty) {
            res.push(<Box sx={{marginTop: 2}} key={"empty"}>
                <Typography sx={{width: "100%"}} color={"#ccc"} variant="body2" display="block"
                            gutterBottom>Pas de Données dans la base des DPE
                </Typography>
            </Box>);
        }
        return res;
    }

    return (<Box sx={{width: 500, margin: 2, overflow: "hidden"}} ref={printRef}>
        <Box sx={{
            p: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: 55
        }}>
            <Box sx={{
                p: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "column",
                height: 24,
                fontWeight: 'bold'
            }}>

                <Typography
                    sx={{color: "#fff", backgroundColor: "#1f0d88", p: 1.2, borderRadius: 1, fontWeight: 'bold'}}

                    variant="body"
                    display="block"
                >{getAdresse(selectedItem)}
                </Typography>
            </Box>
            <Box sx={{
                color: "#000",
                display: "flex", padding: 1, justifyContent: "flex-end",
                gap: 1
            }}>
                <IconButton
                    onClick={() => {
                        setTakeScreenshot(true);
                    }}>
                    <PrintIcon/>
                </IconButton>
                <IconButton
                    onClick={showDetails}>
                    <ZoomInIcon/>
                </IconButton>
                <IconButton
                    onClick={close}>
                    <CloseIcon/>
                </IconButton>
            </Box>

        </Box>
        {getNbNeighbors(selectedItem) > 1 &&
            <Box sx={{
                display: "flex",
                marginTop: 1,
                marginBottom: 1,
                alignItems: "center",
                justifyContent: "flex-start"
            }}>
                <Box sx={{width: "100%"}}>
                    <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                gutterBottom>Attention : cette adresse fait partie d’un groupe de bâtiment(s)
                        englobant {getNbNeighbors(selectedItem)} adresses différentes
                    </Typography>
                </Box>
            </Box>
        }
        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Année de construction:
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}}
                            color={"#000"} variant="body2" display="block"
                            gutterBottom>{getText(getMeta(selectedItem), "annee_construction")}
                </Typography>
            </Box>
        </Box>
        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Surface Utile calculée :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{getTextNotZero(getMeta(selectedItem), "surface")}
                </Typography>
            </Box>
        </Box>

        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Usage primaire :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{getMultiText(selectedItem.rawBatiments, "usage_niveau_1_txt")}
                </Typography>
            </Box>
        </Box>
        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Usage secondaire :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{checkSecondaire(getText(getMeta(selectedItem), "l_usage_2"))}
                </Typography>
            </Box>
        </Box>
        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Surface commerciale ou tertiaire :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{getText(getMeta(selectedItem), "l_type_equipement")}
                </Typography>
            </Box>
        </Box>
        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Immeuble en co-propriété :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{getMeta(selectedItem).l_nom_copro ? "Oui" : "Non"}
                </Typography>
            </Box>
        </Box>

        <Box sx={{
            display: "flex",
            borderBottomStyle: "dashed",
            borderWidth: "thin",
            borderColor: "#505050",
            marginTop: 1,
            marginBottom: 1,
            alignItems: "center",
            justifyContent: "flex-start"
        }}>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                            gutterBottom>Société ou collectivité propriétaire :
                </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2" display="block"
                            gutterBottom>{Number(getMeta(selectedItem).nb_proprietaires) > 0 ? "Oui" : "Non"}
                </Typography>
            </Box>
        </Box>
        <Box sx={{
            marginTop: 4, width: "100%",

            borderColor: "#ccc",
        }}>
            <Typography sx={{fontWeight: 'bold'}} color={"#00"} variant="body2" display="block"
                        gutterBottom>Classe DPE conso énergie:
            </Typography>
            {getDpes(selectedItem)}
        </Box>
    </Box>)
}

